export class Sales {
    public HasFinancialSeal: boolean;
    public HasFinancialSealValid: boolean;
    public FinancialSealPasswordKnown:boolean;
    public HasTraApplication:boolean;
    constructor(){
        this.HasFinancialSeal = true;
        this.HasFinancialSealValid = true;
        this.FinancialSealPasswordKnown = true;
        this.HasTraApplication = true;
    }
}
